// removed by extract-text-webpack-plugin
module.exports = {"formSection":"_3QiE"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PhoneLine/PhoneLine.scss
// module id = TmEZ
// module chunks = 0